export enum ConversationExperimentStateEnum {
  Pending = 'pending',
  Finished = 'finished',
}
